import { usePost } from './useHttpHooks.ts';
import { FeedbackType } from '../types.ts';

export enum InteractionType {
    PageView,
    QnaSearch,
    TypeAheadClicked,
    FollowUpClicked,
    CategoryClicked,
    TopQuestionClicked,
    FeedbackClicked,
    ArticlePageView,
    ArticleFeedbackClicked
}

export interface TrackInteractionMetadata {
    feedbackType?: FeedbackType | null;
    score?: number | null;
    searchText?: string | null;
    searchInteractionId?: string | null;
    slug?: string | null;
    from?: string | null;
}

export interface TrackInteractionRequest {
    interactionType: InteractionType;
    url: string;
    kbEntryId?: string | null;
    questionId?: number | null;
    metadata: TrackInteractionMetadata | null;
    interactionId: string | null;
}

export interface TrackInteractionResponse {
    interactionId: string;
}

const usePostTrackInteraction = () =>
    usePost<TrackInteractionRequest, TrackInteractionResponse>(
        '/track_interaction',
        {
            errorMessage: 'POST /track_interaction'
        }
    );

export default usePostTrackInteraction;
